
import ProductVideoPreview from '@/components/ProductVideoPreview.vue'

const TILES = 4

export default {
  name: 'CustomerMediaRow',
  components: { ProductVideoPreview },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  computed: {
    items() {
      const videos = (this.media.videos || []).map((movie, index) => ({
        key: `video-${index}`,
        video: movie.video,
        video_preview: movie.video_preview,
        image: movie.image,
      }))
      const photos = (this.media.images || []).map((image, index) => ({
        key: `photo-${index}`,
        video: null,
        image,
      }))
      return [...videos, ...photos]
    },
    total() {
      return (
        (this.media.videos_count ?? (this.media.videos || []).length) +
        (this.media.images_count ?? (this.media.images || []).length)
      )
    },
    shown() {
      return this.items.slice(0, TILES)
    },
    extra() {
      const hidden = this.total - this.shown.length + 1
      return this.shown.length === TILES && hidden > 1 ? hidden : 0
    },
  },
}
